import React from 'react';

import Card from './card.styles';

const CardComponent = ({ children, ...props }) => (
  <Card {...props}>{children}</Card>
);

export default CardComponent;
